<template>
  <h1>Nuovo Inverter</h1>

  <el-form :model="inverter" label-width="240px">
    <el-form-item label="Nome Inverter">
      <el-input v-model="inverter.nome" />
    </el-form-item>
    <el-form-item label="Potenza nominale">
      <el-input-number v-model="inverter.potenzaNominale" />
    </el-form-item>
    <el-form-item label="Marca">
      <el-autocomplete
        v-model="inverter.marca"
        value-key="marca"
        :fetch-suggestions="querySearchMarca"
        :trigger-on-focus="false"
        clearable
        placeholder="Inserisci Marca"
        class="autocomplete"
      />
    </el-form-item>
    <el-form-item label="Modello">
      <el-autocomplete
        v-model="inverter.modello"
        value-key="modello"
        :fetch-suggestions="querySearchModello"
        :trigger-on-focus="false"
        clearable
        placeholder="Inserisci Modello"
        class="autocomplete"
      />
    </el-form-item>

    <el-form-item label="Matricola">
      <el-input v-model="inverter.matricola" />
    </el-form-item>
    <el-form-item label="Note">
      <el-input v-model="inverter.note" type="textarea" />
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="onSubmit"> Aggiungi </el-button>
      <el-button @click="annulla"> Annulla </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { useRoute, useRouter } from 'vue-router';
import { reactive, toRaw, onMounted } from 'vue';
import detailsAPI from '../../services/detailsAPI';
import searchAPI from '../../services/searchAPI';
import { ElMessage } from 'element-plus';
export default {
  setup() {
    //Inizializzo variabili di utility e schema
    const router = useRouter();
    const route = useRoute();
    const sezioneId = route.params.sezioneId;
    const proprietarioId = route.params.id;

    const inverter = reactive({
      nome: '',
      marca: '',
      potenzaNominale: 0,
      note: '',
      modello: '',
      matricola: '',
      fkSezione: sezioneId,
    });

    //Inizializzo i pulsanti
    const onSubmit = () => {
      if (inverter.nome == '') {
        ElMessage({ message: 'Inserire un nome inverter', type: 'warning' });
        return;
      }
      addNewInverter(toRaw(inverter)).then((response) => {
        console.log(response);
        if (response.status === 201) {
          console.log('Inverter aggiunto!');
          router.push(`/details/${proprietarioId}`);
        } else {
          console.log('errore inatteso');
        }
      });
    };

    const annulla = () => {
      router.push(`/details/${proprietarioId}`);
    };

    // Funzioni per aggiungere nuovo
    const addNewInverter = async (inverter) => {
      console.log(inverter);
      let response = {};
      try {
        response = await detailsAPI.addInverter(inverter);
        console.log(response);
        return response;
      } catch {
        console.log('error');
      }
    };

    //Autocomplete funzionalities
    let marca = [];
    let modello = [];

    const querySearchMarca = (queryString, cb) => {
      const results = queryString
        ? marca.filter(createFilterMarca(queryString))
        : marca;
      // call callback function to return suggestions
      cb(results);
    };

    const createFilterMarca = (queryString) => {
      return (item) => {
        return item.marca.toLowerCase().indexOf(queryString.toLowerCase()) == 0;
      };
    };

    const querySearchModello = (queryString, cb) => {
      const results = queryString
        ? modello.filter(createFilterModello(queryString))
        : modello;
      // call callback function to return suggestions
      cb(results);
    };

    const createFilterModello = (queryString) => {
      return (item) => {
        return (
          item.modello.toLowerCase().indexOf(queryString.toLowerCase()) == 0
        );
      };
    };

    onMounted(() => {
      searchAPI.getAutocompleteInverter().then((result) => {
        marca = result.data.marca;
        modello = result.data.modello;
      });
    });

    return {
      proprietarioId,
      inverter,
      onSubmit,
      annulla,
      querySearchMarca,
      querySearchModello,
    };
  },
};
</script>
<style>
.autocomplete {
  width: 100% !important;
}
</style>
